var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 104,
    viewBox: "0 0 120 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_4591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2281 57.8772L100.263 34.761V79.5879C100.263 80.4549 99.7973 81.2671 99.0399 81.696L64.2252 101.801L61.4419 103.407C60.6844 103.845 59.7536 103.845 59.0053 103.407L56.2219 101.801L21.4072 81.696C20.6498 81.258 20.1844 80.4549 20.1844 79.5879V34.761L60.219 57.8772H60.2281Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1935 34.761L60.2281 11.6448L100.263 34.761L60.2281 57.8771L20.1935 34.761Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1935 34.761L60.2281 57.8771L100.263 34.761L60.2281 11.6448L20.1935 34.761Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4789 93.9888L54.4881 87.1443L42.4877 80.0717L42.4786 86.9162L54.4789 93.9888Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2282 57.8772L40.8177 69.0839C40.4435 69.3029 39.9781 69.3029 39.5948 69.0839L1.27586 46.9533C0.7922 46.6704 0.7922 45.9677 1.27586 45.6848L20.1935 34.761L60.2282 57.8772Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2281 11.6448L79.6386 0.438072C80.0127 0.219048 80.4782 0.219048 80.8614 0.438072L119.19 22.5686C119.673 22.8516 119.673 23.5543 119.19 23.8372L100.272 34.761L60.2281 11.6448Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2281 57.8772L79.6386 69.0839C80.0127 69.3029 80.4782 69.3029 80.8614 69.0839L119.19 46.9533C119.673 46.6704 119.673 45.9677 119.19 45.6848L100.272 34.761L60.2373 57.8772H60.2281Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2282 11.6448L40.8268 0.438072C40.4527 0.219048 39.9873 0.219048 39.604 0.438072L1.27586 22.5686C0.7922 22.8516 0.7922 23.5543 1.27586 23.8372L20.1935 34.761L60.2282 11.6448Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2281 57.8772V103.726",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2555 45.4475C72.7295 45.4475 82.8417 35.3351 82.8417 22.8607C82.8417 10.3863 72.7295 0.273804 60.2555 0.273804C47.7815 0.273804 37.6693 10.3863 37.6693 22.8607C37.6693 35.3351 47.7815 45.4475 60.2555 45.4475Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.927 30.6086C64.8158 30.6086 68.779 26.6454 68.779 21.7564C68.779 16.8675 64.8158 12.9042 59.927 12.9042C55.0382 12.9042 51.075 16.8675 51.075 21.7564C51.075 26.6454 55.0382 30.6086 59.927 30.6086Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9874 32.8171L66.169 28.0077",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_4591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.638,
    height: 104,
    fill: "white",
    transform: "translate(0.180771)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection);
export default __webpack_public_path__ + "static/media/inspection.43d2acc4139e973e95d7c4541aa226eb.svg";
export { ForwardRef as ReactComponent };